import React from "react";
import styles from "./BlogSearchResultSkeleton.module.css";

const HITS_PER_PAGE = 12; // Match your BlogSearchResults page size

const BlogSearchResultSkeleton: React.FC = () => {
  return (
    <div
      className={styles.searchSkeletonContainer}
      aria-busy="true"
      aria-label="Cargando resultados de búsqueda"
    >
      {/* Search header skeleton */}
      <div className={styles.searchHeaderSkeleton}>
        <div className={styles.searchInfoSkeleton}>
          <div className={styles.searchTitleSkeleton} />
          <div className={styles.searchCountSkeleton} />
        </div>

        <div className={styles.searchFormSkeleton}>
          <div className={styles.searchInputSkeleton} />
        </div>

        <div className={styles.sortControlSkeleton}>
          <div className={styles.sortLabelSkeleton} />
          <div className={styles.sortSelectSkeleton} />
        </div>
      </div>

      {/* Search results skeleton */}
      <div className={styles.resultsContainerSkeleton}>
        {Array(HITS_PER_PAGE)
          .fill(0)
          .map((_, index) => (
            <div
              key={index}
              className={styles.resultItemSkeleton}
              role="status"
              aria-label="Cargando artículo"
            >
              <div className={styles.resultImageSkeleton} />
              <div className={styles.resultContentSkeleton}>
                <div className={styles.resultCategoriesSkeleton}>
                  <div className={styles.categorySkeleton} />
                  <div className={styles.categorySkeleton} />
                </div>
                <div className={styles.resultTitleSkeleton} />
                <div className={styles.resultDescriptionSkeleton}>
                  <div className={styles.descriptionLineSkeleton} />
                  <div className={styles.descriptionLineSkeleton} />
                  <div
                    className={styles.descriptionLineSkeleton}
                    style={{ width: "70%" }}
                  />
                </div>
                <div className={styles.resultAuthorSkeleton}>
                  <div className={styles.authorAvatarSkeleton} />
                  <div className={styles.authorNameSkeleton} />
                </div>
              </div>
            </div>
          ))}
      </div>

      {/* Pagination skeleton */}
      <div className={styles.paginationSkeleton} />
    </div>
  );
};

export default BlogSearchResultSkeleton;
